export default {

    init() {
        console.log('init collapse...');
		document.addEventListener("DOMContentLoaded", this.bindEvents);
    },

    bindEvents() {
        $('[data-collapse]').on('click', function(e) {
            Collapse.toggleVisibility(this);
        });
    },

    toggleVisibility(elem) {
        let $toggle = $(elem);
        let $target = $('#'+$toggle.attr('aria-controls'));
        let moreText = $toggle.attr('data-text-more') ? $toggle.attr('data-text-more') : 'View more'
        let lessText = $toggle.attr('data-text-less') ? $toggle.attr('data-text-less') : 'View less'

        if(!$target.length) {
            return;
        }

        if($target[0].hasAttribute('hidden')) {
            $target.removeAttr('hidden').addClass('is-active');
            $toggle.attr('aria-expanded', 'true').text(lessText);
        } else {
            $target.removeClass('is-active').attr('hidden', true);
            $toggle.attr('aria-expanded', 'false').text(moreText);
        }
    }
    
};